import i18n from '@/translator'

const initialStates = function () {
  return {
    language: i18n.locale,
    joinImage: require('@/assets/Landing/Join.en.png')
  }
}

const mutations = {
  setLanguage (state, value) {
    state.language = value
  },
  getLinkImage (state, value) {
    state.joinImage = require(`@/assets/Landing/Join.${value}.png`)
  }
}

const actions = {
  setLanguage ({commit}, value) {
    localStorage.setItem('language', value)
    i18n.locale = value
    commit('setLanguage', value)
    commit('getLinkImage', value)
  }
}

const getters = {
  language: state => {
    return state.language
  },
  joinImage: state => {
    return state.joinImage
  },
  isCurrentLanguage: (state) => (lang) => {
    return state.language === lang
  }
}

const translator = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default translator



// WEBPACK FOOTER //
// ./src/store/modules/translator.js